import React, { Component } from "react";
import _ from "lodash";
import { decode } from "he"; //for properly displaying apostrophies in sermon titles

import AudioPlayer from "react-responsive-audio-player";

import { getFromDrupalAPI } from "./fetchJSON.js";

const currentYear = new Date().getFullYear();

class Footer extends Component {
	constructor() {
		super();
		this.state = {
			recentSermons: null
		};
	}
	componentWillMount() {
		var that = this;
		getFromDrupalAPI("all_sermons_api?limit=1", function (data) {
			that.setState({ latestSermon: data });
		});
	}

	render() {
		var latestSermon = _.map(this.state.latestSermon, (sermon) => {
			return (
				<section key={_.uniqueId()}>
					<strong>{decode(sermon.node_title)}</strong>
					<br />
					{sermon.preacher}
					<br />
					<AudioPlayer playlist={[{ url: sermon.url }]} controls={["playpause", "spacer", "progress"]} />
					<a href={sermon.url} target="_blank" rel="noreferrer noopener">
						Download File
					</a>
				</section>
			);
		});

		return (
			<footer>
				<div className="footer-bar">
					<div className="container">
						<span className="copyright">&copy; Kingston Christian Reformed Church {currentYear}</span>
						<a className="toTop" href="#topNav">
							BACK TO TOP <i className="fa fa-arrow-circle-up"></i>
						</a>
					</div>
				</div>

				<div className="footer-content">
					<div className="container">
						<div className="row">
							<div className="column col-md-4">
								<h3 className="text-center">SERVICE TIME</h3>

								<address className="font-opensans">
									<ul>
										<li style={{ marginBottom: 20 }}>
											{/*9:00am and 10:45am Sundays<br />*/}
											10:00am and 4:30pm Sundays <br />
										</li>
										<li className="footer-sprite address">
											<a
												href='http://www.google.com/maps?q="17 Denison Street, Kingston, Tasmania"'
												target="_blank"
												rel="noopener noreferrer"
											>
												17 Denison St, Kingston
											</a>
											<br />
										</li>
									</ul>
								</address>
							</div>

							<div className="column col-md-4">
								<h3 className="text-center">CONTACT US</h3>

								<address className="font-opensans">
									<ul>
										<li style={{ marginBottom: 20, paddingLeft: 30 }}>
											Office Hours<br />
											Monday: CLOSED<br />
											Tuesday: 10.30am - 3pm<br />
											Wednesday: 10.30am - 12.30pm<br />
											Thursday: 10.30am - 3pm<br />
											Friday: 10.30am - 3pm
										</li>
										<li className="footer-sprite phone">Phone: (03) 6229 2268</li>
										<li className="footer-sprite email">
											<a href="mailto:office@kingstoncrc.org.au">office@kingstoncrc.org.au</a>
										</li>
										<li>Find Us on</li>
										<li>
											<span style={{ fontSize: "1.85em" }}>
												<i className="fa fa-facebook-official" />{" "}
											</span>{" "}
											&nbsp;
											<a href="https://www.facebook.com/KingstonCRC" target="_blank" rel="noopener noreferrer">
												Facebook
											</a>
										</li>
										<li>
											<span style={{ fontSize: "1.85em" }}>
												<i className="fa fa-instagram" />{" "}
											</span>{" "}
											&nbsp;
											<a href="https://www.instagram.com/kingstoncrc/" target="_blank" rel="noopener noreferrer">
												Instagram
											</a>
										</li>
									</ul>
								</address>
							</div>

							<div className="column col-md-4">
								<h3 className="text-center">LATEST SERMON</h3>

								{latestSermon}

								<a href="/Sermons" className="view-more pull-right">
									More Sermons <i className="fa fa-arrow-right"></i>
								</a>
							</div>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;
